import ScrollMagic from "ScrollMagic";
import { TweenMax, TimelineMax } from "gsap/all";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import "ScrollMagic/scrollmagic/uncompressed/plugins/debug.addIndicators";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default ScrollMagic;
